import { useScrollReveal } from '@/hooks/useScrollReveal';

interface ScrollRevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  duration?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  once?: boolean;
  threshold?: number;
  as?: 'div' | 'section' | 'article' | 'span' | 'li';
}

const directionStyles: Record<string, { from: string; to: string }> = {
  up: { from: 'translate-y-8', to: 'translate-y-0' },
  down: { from: '-translate-y-8', to: 'translate-y-0' },
  left: { from: 'translate-x-8', to: 'translate-x-0' },
  right: { from: '-translate-x-8', to: 'translate-x-0' },
  none: { from: '', to: '' },
};

export default function ScrollReveal({
  children,
  className = '',
  delay = 0,
  duration = 600,
  direction = 'up',
  once = true,
  threshold = 0.12,
  as: Tag = 'div',
}: ScrollRevealProps) {
  const { ref, isVisible } = useScrollReveal({ threshold, triggerOnce: once });
  const dir = directionStyles[direction];

  const style = {
    transitionDuration: `${duration}ms`,
    transitionDelay: `${delay}ms`,
    transitionTimingFunction: 'cubic-bezier(0.22, 1, 0.36, 1)',
  } as React.CSSProperties;

  return (
    <Tag
      ref={ref}
      className={`transition-all ${className} ${
        isVisible
          ? `opacity-100 ${dir.to}`
          : `opacity-0 ${dir.from}`
      }`}
      style={style}
    >
      {children}
    </Tag>
  );
}